
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { FilterMatchMode, FilterOperator } from 'primevue/api'
import InputText from 'primevue/inputtext'
import OverlayPanel from 'primevue/overlaypanel'

import Tag from 'primevue/tag'
import importExportDescriptor from '../ImportExportDescriptor.json'
import { IGalleryTemplate } from '@/modules/managers/galleryManagement/GalleryManagement'

export default defineComponent({
    name: 'import-export-gallery',
    components: { Column, DataTable, InputText, OverlayPanel, Tag },
    props: { selectedItems: Object },
    data() {
        return {
            currentImage: '',
            filters: {},
            importExportDescriptor: importExportDescriptor,
            product: {},
            selectedGalleryItems: [],
            templates: [] as Array<IGalleryTemplate>,
            FUNCTIONALITY: 'gallery'
        }
    },
    created() {
        this.filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            type: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            tags: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
        }
        this.loadAllTemplates()
    },
    emits: ['onItemSelected', 'update:loading'],
    methods: {
        loadAllTemplates(): void {
            this.$emit('update:loading', true)
            this.axios
                .get(process.env.VUE_APP_API_PATH + '1.0/widgetgallery')
                .then((response: AxiosResponse<any>) => {
                    this.templates = response.data
                    if (this.selectedItems) {
                        this.selectedGalleryItems = this.selectedItems[this.FUNCTIONALITY].filter((element) => {
                            return this.templates.filter((el) => el.id === element.id).length == 1
                        })
                    }
                })
                .catch((error) => console.error(error))
                .finally(() => {
                    this.$emit('update:loading', false)
                })
        },
        togglePreview(event, id) {
            this.currentImage = ''

            this.$http.get(process.env.VUE_APP_API_PATH + '1.0/widgetgallery/image/' + id).then(
                (response: AxiosResponse<any>) => {
                    console.log(response)
                    this.currentImage = response.data
                },
                (error) => console.error(error)
            )
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.op.toggle(event)
        }
    },
    watch: {
        selectedGalleryItems(newSelectedGalleryItems, oldSelectedGalleryItems) {
            if (oldSelectedGalleryItems != newSelectedGalleryItems) {
                this.$emit('onItemSelected', { items: this.selectedGalleryItems, functionality: this.FUNCTIONALITY })
            }
        }
    }
})
